module.exports = __webpack_public_path__ + "assets/img/yyindex-4.f62e33df.png";